 <!-- el codigo de esta ventana fue copiado de la vista Mudanza/Second-->
<template>
  <v-container
    :class="{
      'pa-0': $vuetify.breakpoint.smAndDown,
      'px-5 py-5': $vuetify.breakpoint.mdAndUp,
    }"
    >
    <div class="overlay-loading" v-if="loadingPedido">
      <LoadingLogo />
    </div>
    <v-layout row wrap xs12>
      <v-flex
        md6
        sm6
        xs12
        :class="{
          'px-0': $vuetify.breakpoint.smAndDown,
          'px-2': $vuetify.breakpoint.mdAndUp,
        }"
      >
        <v-layout row wrap>
          <v-flex
            sx12
            px-0
            class="search-element-container"
            ref="searchContainer"
            :style="{ height: searchContainerHeight + 64 + 'px' }"
          >
            <v-text-field
              class="mx-0 barra-busqueda-express pointer"
              flat
              label="Buscar Aqui lo que quieres mover"
              background-color="#1f97b9"
              height="64px"
              dark
              color="success"
              solo-inverted
              hide-details
              v-model="searchInput"
              @keyup="searchedElement"
            >
              <img id="lupa_img"
                :src="require('../../../assets/static/img/lupa.png')"  
                alt="imagen de la lupa"
                slot="append"
              />
            </v-text-field>
            <v-btn
              class="btn-close-pago-dialog"
              dark
              icon
              v-show="showSearch"
              @click="showSearch = false"
            >
              <v-img
                :src="require('../../../assets/static/img/cerrar.png')"
                 alt="icono de cerrar ventana"
                max-height="25"
                contain
              ></v-img>
            </v-btn>
            <v-list
              two-line
              id="list-suggestions"
              class="list-suggestion"
              v-show="showSearch"
              ref="searchResultContainer"
            >
              <template v-for="(item, index) in searchElements">
                <v-list-tile :key="'sf-' + index" ripple @click="plusElementByFavourite(item)">
                  <v-list-tile-content class="title-elements-list-title">
                    <v-img
                      :src="item.img"
                      max-height="40"
                      max-width="40"
                      class="mr-2"
                      contain
                       alt="imagen del item seleccionado"
                    ></v-img>
                    <v-list-tile-title style="height: auto; line-height: 15px">
                      <small>{{ item.cat }}</small
                      ><br />
                      {{ item.nombre }}
                      
                    </v-list-tile-title>
                    <v-tooltip right max-width="300px">
                      <template slot="activator">
                        <v-layout align-center>
                          <img
                            :src="
                              require('../../../assets/static/img/info.png')"
                             alt="icono de informacion"  
                            class="ml-2"
                            width="16px"
                            height="16px"
                            contain
                          />
                        </v-layout>
                      </template>
                      <span>{{ item.descripcion }}</span>
                    </v-tooltip>
                  </v-list-tile-content>

                  <!--<v-list-tile-action class="actions-element-search">
                    <v-btn
                      color="#1f97b9"
                      style="max-width: 30px; max-height: 30px"
                      fab
                      small
                      dark
                      @click="minusElementbySearch('s-' + index)"
                    >
                      <v-icon small>fas fa-minus</v-icon>
                    </v-btn>-->
                    
                    <!--<v-btn
                      color="#1f97b9"
                      :disabled="
                        elementosCarros.length >= 5 || cantidadElementos >= 5
                      "
                      style="max-width: 30px; max-height: 30px"
                      fab
                      small
                      dark
                      @click="plusElementbySearch('s-' + index)"
                      
                    >
                      <v-icon small>fas fa-plus</v-icon>
                    </v-btn>
                  </v-list-tile-action>-->
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < searchElements.length"
                  :key="'div-' + index"
                ></v-divider>
              </template>
            </v-list>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="!mobile" md3 />
      <!-- carrito-->
        <v-flex  v-if="!mobile"
          md2
          link
          class="carrito"
          style="height: 90px; width: 200px"
          @click="validate(true)"
        >
        <v-flex align-self-center>
        <small style="margin-left: 50px; font-size: 17px; color: #ff9c55;"><b>Cotizar</b></small>
        <!-- <small v-else style="margin-left: 10px; font-size: 17px; color: #1f97b9;">Elige y sigamos</small> -->
        </v-flex>
          <div class="justify-center" style="margin-top: 10px">
            <v-flex style="float: right; margin-right: 30px">
              <h1 id="texto-carrito">{{ cantidadElementos }}/5</h1>
            </v-flex>
            <v-flex style="float: left; margin-left: 30px">
              <v-img
                style="height: 40px; width: 45px"
                :src="require('../../../assets/static/img/carrito2.png')"
                 alt="imagen del carrito">
              </v-img>  
            </v-flex>
          </div>
        </v-flex>
        
          <v-layout justify-center xs12 v-else>
            <v-flex
              link
              style="height: 70px; max-width: 80%;"
              class="carrito"
              @click="validate(true)"
            ><!--style="height: 70px; width: 200px"-->
              <div class="justify-center" style="margin-top: 10px">
               <small v-show="cantidadElementos > 0" style="margin-left: 30px; font-size: 17px; color: #ff9c55;"><b>Cotizar</b></small>
                <v-flex style="float: right; margin-right: 30px">
                  <h1 id="texto-carrito">{{ cantidadElementos }}/5</h1>
                </v-flex>
                <v-flex style="float: left; margin-left: 30px">
                  <v-img
                    style="height: 40px; width: 40px"
                    :src="require('../../../assets/static/img/carrito2.png')"  alt="imagen dle carrito">
                  </v-img>
                </v-flex>
              </div>
            </v-flex>
          </v-layout>  

      </v-layout>  
      <!--FIN carrito-->
      <!--INICIO DE LAS IMAGENES-->    
    <v-layout row wrap>
      <v-layout
        class="layout-seleccionados"
        row
        wrap
        lg12
        md6
        v-for="(el, index) in elementosCarros"
        :key="'sf-' + index"
      >  
        <div>
            <v-flex
              class="elementos-seleccionados"
              round
              value="prueba">
                  <div>     
                  <v-btn class="btn-close-seleccionado"
                    dark
                    icon
                    @click="minusElementSelected(el)"> 
                      <v-img
                        :src="require('../../../assets/static/img/cerrar.png')"
                         alt="icono de cerrar ventana"
                        max-height="20"
                        contain>
                      </v-img>
                  </v-btn>
                </div> 
                <img
                  style="max-heigth: 140px; max-width: 140px;"
                  v-if="el.img !== ''"
                  :src="el.img"
                  alt="imagen del item seleccionado"/>  
            </v-flex> 

          <v-flex sm10  style= " width: 165px;">  
            <small style="font-size: 12px; color: #1f97b9;"> {{el.nombre}} {{el.descripcion}}</small>    
          </v-flex>
        </div>
      </v-layout>
      <v-layout
        class="layout-seleccionados"
        row
        wrap
        lg12
        md6
        v-for="(el, index) in cuadrosSinElementos"
        :key="'sv-' + index"
      >  
        <div>
            <v-flex
              class="elementos-seleccionados"
              round
              value="prueba">
                <div style="text-align: center;">
                  <b style="font-size: 95px; color:#FFC69D">{{el.pos}}</b>
                </div>
                
            </v-flex> 
        </div>
      </v-layout>
    </v-layout>
    <!--FIN DE LAS IMAGENES-->
    <!-- <v-layout row wrap>
      <v-flex md10/>
      <v-flex  v-if="!mobile && cantidadElementos > 0"
          md2
          link
          class="carrito"
          style="height: 90px; width: 200px"
          @click="validate(true)"
        >
        <v-flex align-self-center>
        <small style="margin-left: 50px; font-size: 17px; color: #ff9c55;"><b>Cotizar</b></small>
        </v-flex>
          <div class="justify-center" style="margin-top: 10px">
            <v-flex style="float: right; margin-right: 30px">
              <h1 id="texto-carrito">{{ cantidadElementos }}/5</h1>
            </v-flex>
            <v-flex style="float: left; margin-left: 30px">
              <v-img
                style="height: 40px; width: 40px"
                :src="require('../../../assets/static/img/carrito2.png')"
                 alt="imagen del carrito">
              </v-img>  
            </v-flex>
          </div>
        </v-flex>
      
    </v-layout> -->
<!--Inicio Favoritos--> 
    <!-- <v-layout class="layout-favoritos" v-if="elementosFavoritos.length === 9" row wrap md12 lg12>
      <v-layout row wrap md12 lg12 v-for="(el, i) in elementosFavoritos" :key="i">
        <div>
          <v-flex
            link
            class="elementos-favoritos"
            round
            value="prueba"
            @click="plusElementByFavourite(el)"
            ><img style="max-heigth: 60px; max-width: 60px" :src="el.img" alt="imagen de los elementos favoritos"/>
            <small style="font-size: 12px; color: #1f97b9;"> {{el.nombre}}</small>
          </v-flex>
        </div>
      </v-layout>
      
      <h1 id="texto-elementos-favoritos">
        Acceso Rápido - Elementos movidos con mayor frecuencia
      </h1>
    </v-layout> -->
    <!--fin Favoritos-->
    <v-layout align-end justify-end row wrap>
      <v-flex>
        <v-btn
          color="grey" dark :to="{ name: 'mudanza'}"	
          style="margin-top: 10px; margin-left: 30px;"> 
          Cotizar mas de 5 elementos
        </v-btn>
      </v-flex>
      <v-flex md6></v-flex>
      <v-flex>
        <v-btn id="btn-dialog-carrito"  @click="validate(true)"> 
          Cotizar
        </v-btn>
      </v-flex>      
    </v-layout>       
  </v-container>
</template>

<script>
import { EventBus } from "../../../events.js";
import * as firebase from "firebase/app";
import "firebase/firestore";
import * as ScrollToElement from "scroll-to-element";
import Vue from "vue";
import LoadingLogo from "../../../helpers/LoadingLogo";
import resize from 'vue-resize-directive';
export default {
  name: "mudanzaRapida",
  components: {
    LoadingLogo,
  },
  directives: {
      resize
    },
  data() {
    return {
      /* elementosObjetivos: ['Cama dos plazas','Cama 1 y 1/2 p','Refrigerador Alto','Refrigerador Mediano','Sofa 3 cuerpos'
      ,'Escritorio Chico','Comoda','Sofa 2 cuerpos','Mesa 6 - 8 personas'], */
      elementosObjetivos: ['Living L','Cama 1 y 1/2 p','Refrigerador Alto','Refrigerador Mediano','Sofa 3 cuerpos'
      ,'Escritorio Chico','Comoda','Sofa 2 cuerpos','Mesa 6 - 8 personas'],
      windowWidth: 0,
      mobile: false,
      e1: 1,
      elementos: [],
      manualElement: {},
      element_manual: {},
      totalSearchElements: [],
      searchElements: [],
      searchInput: "",
      showSearch: false,
      selectedElements: [],
      totalElements: 0,
      datos: {},
      counterVolume: 0,
      searchContainerHeight: 0,
      rules: {
        required: [(v) => !!v || "Campo obligatorio"],
      },
      elementosCarros: [],
      elementosFavoritos: [],
      loadingPedido: true,
      cantidadElementos: 0,
      cuadrosSinElementos: [{pos: 1},{pos: 2},{pos: 3},{pos: 4},{pos: 5}],
      labelBuscador: ''

    };
  },
  methods: {
    getLabel() {
      let label = ''
      const textoFijo = 'Buscar Elemento en DUO'
      const interval = setInterval(function() {
        label = ''
        const arrayTexto = Array.from(textoFijo)
        for (let i = 0; i < arrayTexto.length; i++) {
          label += arrayTexto[i]
          console.log(label)
          
        }
        if (label === textoFijo) {
          clearInterval(interval)
        }
      },1000)
      
    },
    getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth
      	this.mobile = false
        if( this.windowWidth < 762 ){
        	this.mobile = true
        }
      },
     isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
      } else {
       return false
      }
    },
         
    retroceder(){
      this.eventTracker('goBackExpressSecond')
      EventBus.$emit('retrocederExpress', 1)
    },

    validate(move) {
      if (this.selectedElements.length > 0) {
        var data = {
          datos: this.selectedElements,
          valid: true,
          move,
        };
        if (move) {
          this.eventTracker('goForwardExpressSecond')
          EventBus.$emit("mudanzaExpressSecond", data);
        }
      }
    },
    test(e) {
      const parent = e.target.closest("li.v-expansion-panel__container");
      const searched = parent.querySelector(".v-expansion-panel__body .v-card");
      const here = this;
      if (searched === null) {
        setTimeout(function () {
          here.test(e);
        }, 200);
      } else {
        setTimeout(function () {
          here.scrollTo(e);
        }, 500);
      }
    },
    scrollToELements() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        const element = document.querySelector(".listado-seleccionados");
        ScrollToElement(element, {
          offset: -120,
          ease: "in-out-sine",
          duration: 700,
        });
      }
    },
    scrollTo(element) {
      ScrollToElement(element.target, {
        offset: -20,
        ease: "in-out-sine",
        duration: 700,
      });
    },
    searchedElement() {
      const self = this;
      this.searchElements = this.totalSearchElements.filter(function (el) {
        if (
          el.nombre.toLowerCase().search(self.searchInput.toLowerCase()) !==
            -1 ||
          el.descripcion
            .toLowerCase()
            .search(self.searchInput.toLowerCase()) !== -1
        ) {
          return true;
        } else {
          return false;
        }
      });
      if (this.searchInput.length > 2) {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    },
    plusElementByFavourite(el) {
      if (this.elementosCarros.length < 5) {
        el.escaleraO = false;
        el.escaleraD = false;
        el.qty = 1;
        this.selectedElements.push(el);
        this.elementosCarros.push(el);
        this.cantidadElementos++;
        this.showSearch = false
        this.searchInput = ""
        this.cuadrosSinElementos.pop()
        if (this.cuadrosSinElementos.length < 5) {
          this.cuadrosSinElementos.forEach(function(cuadro) {
            cuadro.pos++
          })
        }

      }
    },
    minusElementSelected(el) {
      var foundIndex = this.selectedElements.findIndex(
        (x) => x.nombre == el.nombre
      );
      var foundIndexCarro = this.elementosCarros.findIndex(
        (x) => x.nombre == el.nombre
      );
      this.selectedElements.splice(foundIndex, 1);
      this.elementosCarros.splice(foundIndexCarro, 1);
      this.cantidadElementos--;
      if (this.cuadrosSinElementos.length <= 5) {
        const diferencia = 5 - this.cuadrosSinElementos.length
        const data = {
          pos: (this.cuadrosSinElementos.length + 1) + diferencia
        }
        this.cuadrosSinElementos.push(data)
      }
      this.cuadrosSinElementos.forEach(function(cuadro) {
        cuadro.pos--
      })
    },
    plusElementbySearch(el) {
      let qty = parseInt(this.$refs[el][0].innerText);
      qty++;
      this.$refs[el][0].innerText = qty;
      if (qty || qty == "") {
        let indexes = el.split("-");
        let newElement = {
          qty: parseInt(qty),
          escaleraO: false,
          escaleraD: false,
        };
        let newObjectElement = Object.assign(
          newElement,
          this.searchElements[indexes[1]]
        );

        var foundIndex = this.selectedElements.findIndex(
          (x) => x.nombre == newObjectElement.nombre
        );
        if (foundIndex != -1) {
          this.selectedElements[foundIndex].qty = newObjectElement.qty;
          this.cantidadElementos++;
          if (newObjectElement.qty == 0) {
            this.selectedElements.splice(foundIndex, 1);
            this.elementosCarros.splice(foundIndex, 1);
          }
        } else {
          if (this.elementosCarros.length < 5) {
            this.elementosCarros.push(newObjectElement);
            this.selectedElements.push(newObjectElement);
            this.cantidadElementos++;
          }
        }
        this.countElements();
        this.showSearch = false
      }
    },
    plusElementbySearchBar(el) {
      let qty = parseInt(this.$refs[el][0].innerText);
      qty++;
      this.$refs[el][0].innerText = qty;
      if (qty || qty == "") {
        let indexes = el.split("-");
        let newElement = {
          qty: parseInt(qty),
          escaleraO: false,
          escaleraD: false,
        };
        let newObjectElement = Object.assign(
          newElement,
          this.searchElements[indexes[1]]
        );

        var foundIndex = this.selectedElements.findIndex(
          (x) => x.nombre == newObjectElement.nombre
        );
        if (foundIndex != -1) {
          this.selectedElements[foundIndex].qty = newObjectElement.qty;
          this.cantidadElementos++;
          if (newObjectElement.qty == 0) {
            this.selectedElements.splice(foundIndex, 1);
            this.elementosCarros.splice(foundIndex, 1);
          }
        } else {
          if (this.elementosCarros.length < 5) {
            this.elementosCarros.push(newObjectElement);
            this.selectedElements.push(newObjectElement);
            this.cantidadElementos++;
            
          }
        }
        this.countElements();
        this.showSearch = false;
        this.searchInput = "";
      }
    },
    minusElementbySearch(el) {
      let qty = parseInt(this.$refs[el][0].innerText);
      if (qty > 0) {
        qty--;
        this.$refs[el][0].innerText = qty;
        if (qty || qty == "") {
          let indexes = el.split("-");
          let newElement = {
            qty: parseInt(qty),
            escaleraO: false,
            escaleraD: false,
          };
          let newObjectElement = Object.assign(
            newElement,
            this.searchElements[indexes[1]]
          );

          var foundIndex = this.selectedElements.findIndex(
            (x) => x.nombre == newObjectElement.nombre
          );
          if (foundIndex != -1) {
            this.selectedElements[foundIndex].qty = newObjectElement.qty;
            this.cantidadElementos--;
            if (newObjectElement.qty == 0) {
              this.elementosCarros.splice(foundIndex, 1);
              this.selectedElements.splice(foundIndex, 1);
            }
          } else {
            this.selectedElements.push(newObjectElement);
          }
          this.countElements();
        }
      }
    },
    addElementbySearch(el) {
      let qty = this.$refs[el][0].$refs.input.value;
      if (qty == "") {
        qty = 0;
      }
      if (qty || qty == "") {
        let indexes = el.split("-");
        let newElement = {
          qty: parseInt(qty),
          escaleraO: false,
          escaleraD: false,
        };
        let newObjectElement = Object.assign(newElement, {
          nombre: this.searchElements[indexes[1]].nombre,
          metros: this.searchElements[indexes[1]].metros,
        });

        var foundIndex = this.selectedElements.findIndex(
          (x) => x.nombre == newObjectElement.nombre
        );
        if (foundIndex != -1) {
          this.selectedElements[foundIndex].qty = newObjectElement.qty;
          if (newObjectElement.qty == 0) {
            this.selectedElements.splice(foundIndex, 1);
          }
        } else {
          this.selectedElements.push(newObjectElement);
        }
        this.countElements();
      }
    },
    removeElement(index) {
      this.selectedElements.splice(index, 1);
      this.countElements();
    },
    countElements() {
      const here = this;
      let counter = 0;
      let counterVolume = 0;
      this.selectedElements.map(function (item) {
        counter = counter + item.qty;
        counterVolume = counterVolume + item.qty * item.metros;
        counterVolume = Math.round(counterVolume * 100) / 100;
      });
      this.counterVolume = counterVolume;
      this.totalElements = counter;
    },
    eventTracker(tipo) {
      gtag("event", tipo, {
        event_category: tipo,
        event_label: tipo,
      });
    },
    /*async getFavorites() {
      const db = firebase.firestore()
      const here = this
      await db.collection('elementosFavoritos').doc('elementosFavoritos').get().then(function(doc) {
        if (!doc.isEmpty) {
          const data = doc.data()
          console.log('ElementosFavoritos===========')
          console.log(data)
          here.elementosFavoritos = data.elementosFavoritos
        }
      })
    },*/
  },
  watch: {
    searchElements: function () {
      const here = this;
      this.$nextTick(() => {
        here.searchContainerHeight =
          here.$refs.searchResultContainer.$el.clientHeight;
      });
    },
    showSearch: function (val) {
      if (!val) {
        this.searchContainerHeight = 0;
      }
    },
  },
  async mounted() {
    this.$nextTick(function() {
	      window.addEventListener('resize', this.getWindowWidth)
	      this.getWindowWidth()
	    })
    let db = firebase.firestore()
    let self = this
    await db
      .collection("elementos")
      .get()
      .then((querySnapshot) => {
        let contador = 0;
        querySnapshot.forEach(async (doc) => {
          const elementos = doc.data()

           //console.log(elementos) 
          if (!elementos.manual ) {
            self.elementos.push(elementos)
            //console.log(self.elementos)
            await elementos.elementos.forEach(async (elemento) => {
              let data = elemento
              self.totalSearchElements.push(data)
              
              //if (self.elementosFavoritos.length < 9) {
                await self.elementosObjetivos.forEach(function(nombreElemento) {
                  if (nombreElemento === data.nombre) {
                    const index = self.elementosObjetivos.indexOf(nombreElemento)
                    self.elementosFavoritos[index] = data
                    contador++
                    self.elementosFavoritos.length > 8 ? self.loadingPedido = false : self.loadingPedido
                  }
                })
              // }
              
            });
          } else {
            self.element_manual = doc.data()
          }
        })
        self.elementos.sort(function (a, b) {
          if (a.datos.posicion > b.datos.posicion) {
            return 1
          }
          if (a.datos.posicion < b.datos.posicion) {
            return -1
          }
          return 0
        })
      })
      // self.getFavorites()
      /* setInterval(function() {
        const interval = setInterval(function() {
          this.labelBuscador = ''
          let contador = 0
          const textoFijo = 'Buscar Elemento en DUO'
          const arrayTexto = Array.from(textoFijo)
          for (let i = 0; i < arrayTexto.length; i++) {
            this.labelBuscador += arrayTexto[i]
            console.log(this.labelBuscador)
            contador++
          }
          if (contador === textoFijo.length) {
            clearInterval(interval)
          }
        },1000)
      },2000) */
      
  },
  
}
</script>